import { computed } from 'vue'
import stores from '../stores'

export const configInstagram = computed(() => {
  const setting = stores.getStoresData().setting?.find(
    (setting: { key: string }) => setting.key === 'config_instagram'
  )

  return setting?.value || ''
})
